import AppModal from './AppModal';

export default AppModal;
